import React from 'react'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import { ModalBig } from '@/modules/base/components/modal'
import { SubscriptionTypeTypes } from '@/modules/base/util/constants'
import { ButtonIconSquare, CancelButton } from '@/modules/base/components/buttons'
import ThemeInterface from '@/theme-interface'
import { SubTitle, Title } from '@/modules/base/components/texts'
import trialBannerUrl from '@assets/images/document/trial-banner.png'
import DocumentLogoIcon from '@assets/images/document/logo-dokumente.svg'
import IconCheck from '@assets/images/icons/check_thin.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import TrialModalDefault from '@/modules/base/components/modal/trial-modal/trial-modal-default'
import { TrialModalProps } from '@/modules/base/components/modal/trial-modal/trial-modal-props'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  modal: {
    background: '#032750',
    padding: theme.spacing(8),
    height: '600px',
  },
  container: {
    display: 'flex',
    color: theme.white,
    height: '100%',
    width: '100%',
  },
  left: {
    padding: '0px 16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    '& svg': {
      width: 'fit-content',
    },
  },
  title: {
    marginBottom: 0,
    width: '80%',
    lineHeight: theme.fontSizes.huge,
    padding: '10px 0px',
  },
  subtitle: {
    width: '65%',
    fontSize: theme.fontSizes.smedium,
    color: theme.white,
    lineHeight: theme.fontSizes.xlarge,
  },
  bulletPointContainer: {
    marginBottom: '1em',
  },
  buttonContainer: {
    display: 'flex',
  },
  cancelButton: {
    background: 'transparent',
    border: 'none',
    color: '#84b9f5',
    transition: ' 0.1s',
    '&:hover': {
      color: '#a7d4ff',
      background: 'transparent !important',
    },
  },
  imageContainer: {
    display: 'flex',
  },
  image: {
    maxHeight: '100%',
  },
}))

const icons = {
  'check': <SVGIcon svg={IconCheck} fill={'#A2C62E'} width={'12px'} />,
}

const BulletPoint = ({ sentence, className }) => {
  return (
    <p className={className.bulletPoint}>{icons[sentence.icon]} &nbsp; {sentence.text} {sentence.subText}</p>
  )
}
// TODO adapt later for trial staff
const TEXTS = lang.myAccount.documentTrialModal

const TrialModalMbo = (props: TrialModalProps) => {
  const { open, productType, dataQsId, onClose, onStartTrial } = props
  const classes = useStyles()

  return productType === SubscriptionTypeTypes.Document
    ? (
      <ModalBig
        open={open}
        onClose={onClose}
        className={classes.modal}
        showCloseIcon={false}
        width={1000}
        dataQsId={dataQsId}
      >
        <div className={classes.container}>
          <div className={classes.left}>
            <SVGIcon svg={DocumentLogoIcon} height={30} fill={'#fff'} />
            <Title size='large' className={classes.title}>{TEXTS?.title}</Title>
            <SubTitle customClass={classes.subtitle}>{TEXTS?.subTitle}</SubTitle>
            <div className={classes.bulletPointContainer}>
              {TEXTS?.bulletPoints.map((sentence, key) =>
                <BulletPoint sentence={sentence} key={key} className={classes} />,
              )}
            </div>
            <div className={classes.buttonContainer}>
              <ButtonIconSquare
                dataQsId={`${dataQsId}-confirm`}
                key='confirm'
                type='submit'
                label={TEXTS?.confirmButtonLabel}
                onClick={onStartTrial}
              />
              <CancelButton
                dataQsId={`${dataQsId}-cancel`}
                key='cancel'
                type='cancel'
                customClass={classes.cancelButton}
                label={TEXTS?.cancelButtonLabel}
                onClick={onClose}
              />
            </div>
          </div>
          <div className={classes.imageContainer}>
            <img src={trialBannerUrl} width={390} className={classes.image} />
          </div>
        </div>
      </ModalBig>
    )
    : (
      <TrialModalDefault
        open={open}
        dataQsId={dataQsId}
        onStartTrial={onStartTrial}
        onClose={onClose}
        productType={productType} />
    )
}

export default TrialModalMbo
